const MESSAGE_TAIL_POSITIONS = {
  left: "left",
  right: "right",
};

export default MESSAGE_TAIL_POSITIONS;
